import React, { FC, ReactElement } from "react";
import Link from "next/link";
import LogoIcon from "assets/icons/logo_new.svg";
import { useUrl } from "helpers/hooks";
import { cn } from "helpers/style";
import styles from "./Logo.module.scss";

type Props = {
  mobileIsOpen?: boolean;
  showOnTablet?: boolean;
  onClick?: () => void;
};

const Logo: FC<Props> = ({
  mobileIsOpen,
  showOnTablet,
  onClick,
}: Props): ReactElement => {
  const { getLinkProps } = useUrl();
  return (
    <div
      className={cn([
        styles.logo,
        mobileIsOpen && styles.mobileOpen,
        showOnTablet && styles.showOnTable,
      ])}
      onClick={onClick}
    >
      <Link {...getLinkProps("/")} aria-label="Заголовок" passHref>
        <LogoIcon />
      </Link>
    </div>
  );
};

export default Logo;
